export const CONVERSATIONS = 'Conversations';
export const KEYWORDS = 'Keywords';

export const BLOCKED_KEYWORDS = [
  'HELP',
  'INFO',
  'START',
  'UNSTOP',
  'STOP',
  'STOPALL',
  'END',
  'CANCEL',
  'QUIT',
];

// What the reply composer's file picker offers. A convenience for the user, not a
// control: the server derives the real type from the file's bytes and refuses
// anything off its own allowlist regardless of what this attribute says.
export const OUTBOUND_MEDIA_ACCEPT =
  '.png,.jpeg,.jpg,.gif,.webp,.heif,.heic,.pdf';

// Shown when the server had to shrink an attachment far enough that the
// recipient gets a visibly smaller image than the file the user picked. The
// server sets `degraded` on the upload response; see `DEGRADED_LONG_EDGE` in
// andromeda's media policy for where the line sits and why.
//
// Says "resized" rather than "compressed" on purpose: the downscale is what the
// flag now tracks, and it is what a recipient would notice. It lives here alone
// so that swapping it stays a one-line change.
export const MEDIA_COMPRESSION_WARNING =
  'This image was resized to fit carrier size limits and may look lower quality.';
